/*!
 * devextreme-angular-test
 * Version: 17.2.8
 * Build date: Mon Feb 05 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */











import {
    Component,
    NgModule,
    ElementRef,
    NgZone,
    Input,
    Output,
    OnDestroy,
    Injector,
    EventEmitter
} from '@angular/core';



import DxLoadIndicator from 'devextreme/ui/load_indicator';


import { DxComponent } from '../core/component';
import { DxTemplateHost } from '../core/template-host';
import { DxTemplateModule } from '../core/template';
import { EventsRegistrator } from '../core/events-strategy';
import { NestedOptionHost } from '../core/nested-option';
import { WatcherHelper } from '../core/watcher-helper';







/**
 * The LoadIndicator is a UI element notifying the viewer that a process is in progress.
 */

export class DxLoadIndicatorComponent extends DxComponent implements OnDestroy {
    instance: DxLoadIndicator;


    /**
     * Specifies the attributes to be attached to the widget's root element.
     */
    
    get elementAttr(): any {
        return this._getOption('elementAttr');
    }
    set elementAttr(value: any) {
        this._setOption('elementAttr', value);
    }


    /**
     * Specifies the widget's height.
     */
    
    get height(): number|
        Function|
        string {
        return this._getOption('height');
    }
    set height(value: number|
        Function|
        string) {
        this._setOption('height', value);
    }


    /**
     * Specifies text for a hint that appears when a user pauses on the widget.
     */
    
    get hint(): string {
        return this._getOption('hint');
    }
    set hint(value: string) {
        this._setOption('hint', value);
    }


    /**
     * Specifies the path to an image used as the indicator.
     */
    
    get indicatorSrc(): string {
        return this._getOption('indicatorSrc');
    }
    set indicatorSrc(value: string) {
        this._setOption('indicatorSrc', value);
    }


    /**
     * Switches the widget to a right-to-left representation.
     */
    
    get rtlEnabled(): boolean {
        return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value: boolean) {
        this._setOption('rtlEnabled', value);
    }


    /**
     * Specifies whether the widget is visible.
     */
    
    get visible(): boolean {
        return this._getOption('visible');
    }
    set visible(value: boolean) {
        this._setOption('visible', value);
    }


    /**
     * Specifies the widget's width.
     */
    
    get width(): number|
        Function|
        string {
        return this._getOption('width');
    }
    set width(value: number|
        Function|
        string) {
        this._setOption('width', value);
    }

    /**
     * A handler for the contentReady event. Executed when the widget's content is ready. This handler may be executed multiple times during the widget's lifetime depending on the number of times its content changes.
     */
     onContentReady: EventEmitter<any>;

    /**
     * A handler for the disposing event. Executed when the widget is removed from the DOM using the remove(), empty(), or html() jQuery methods only.
     */
     onDisposing: EventEmitter<any>;

    /**
     * A handler for the initialized event. Executed only once, after the widget is initialized.
     */
     onInitialized: EventEmitter<any>;

    /**
     * A handler for the optionChanged event. Executed after an option of the widget is changed.
     */
     onOptionChanged: EventEmitter<any>;

    /**
     * A handler for the elementAttrChange event.
     */
     elementAttrChange: EventEmitter<any>;

    /**
     * A handler for the heightChange event.
     */
     heightChange: EventEmitter<number|
        Function|
        string>;

    /**
     * A handler for the hintChange event.
     */
     hintChange: EventEmitter<string>;

    /**
     * A handler for the indicatorSrcChange event.
     */
     indicatorSrcChange: EventEmitter<string>;

    /**
     * A handler for the rtlEnabledChange event.
     */
     rtlEnabledChange: EventEmitter<boolean>;

    /**
     * A handler for the visibleChange event.
     */
     visibleChange: EventEmitter<boolean>;

    /**
     * A handler for the widthChange event.
     */
     widthChange: EventEmitter<number|
        Function|
        string>;





    constructor(elementRef: ElementRef, ngZone: NgZone, templateHost: DxTemplateHost, injector: Injector,
            _watcherHelper: WatcherHelper, optionHost: NestedOptionHost) {

        super(elementRef, ngZone, templateHost, _watcherHelper);
        injector.get(EventsRegistrator);

        this._createEventEmitters([
            { subscribe: 'contentReady', emit: 'onContentReady' },
            { subscribe: 'disposing', emit: 'onDisposing' },
            { subscribe: 'initialized', emit: 'onInitialized' },
            { subscribe: 'optionChanged', emit: 'onOptionChanged' },
            { emit: 'elementAttrChange' },
            { emit: 'heightChange' },
            { emit: 'hintChange' },
            { emit: 'indicatorSrcChange' },
            { emit: 'rtlEnabledChange' },
            { emit: 'visibleChange' },
            { emit: 'widthChange' }
        ]);
        optionHost.setHost(this);
    }

    protected _createInstance(element, options) {
        return new DxLoadIndicator(element, options);
    }

    ngOnDestroy() {
        this._destroyWidget();
    }


static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'dx-load-indicator',
    template: '',
    providers: [
        DxTemplateHost,
        WatcherHelper,
        NestedOptionHost
    ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: NgZone, },
{type: DxTemplateHost, },
{type: Injector, },
{type: WatcherHelper, },
{type: NestedOptionHost, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'elementAttr': [{ type: Input },],
'height': [{ type: Input },],
'hint': [{ type: Input },],
'indicatorSrc': [{ type: Input },],
'rtlEnabled': [{ type: Input },],
'visible': [{ type: Input },],
'width': [{ type: Input },],
'onContentReady': [{ type: Output },],
'onDisposing': [{ type: Output },],
'onInitialized': [{ type: Output },],
'onOptionChanged': [{ type: Output },],
'elementAttrChange': [{ type: Output },],
'heightChange': [{ type: Output },],
'hintChange': [{ type: Output },],
'indicatorSrcChange': [{ type: Output },],
'rtlEnabledChange': [{ type: Output },],
'visibleChange': [{ type: Output },],
'widthChange': [{ type: Output },],
};
}


export class DxLoadIndicatorModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    DxTemplateModule
  ],
  declarations: [
    DxLoadIndicatorComponent
  ],
  exports: [
    DxLoadIndicatorComponent,
    DxTemplateModule
  ],
  providers: [EventsRegistrator]

}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
